import styled from '@emotion/styled';

export const InputsContainer = styled('div', { label: 'InputsContainer' })`
    display: flex;
    position: relative;
    margin-left: -2.5px;
    margin-right: -2.5px;
`;

export const InputWrapper = styled('div', { label: 'InputWrapper' })`
    flex: 0 0 50%;
    box-sizing: border-box;
    position: relative;
    float: left;
    padding-left: 2.5px;
    padding-right: 2.5px;
    min-height: 1px;
    .react-datepicker-wrapper {
        display: flex;
    }
    .react-datepicker__aria-live {
        display: none;
    }
    .react-datepicker__tab-loop {
        .react-datepicker-popper {
            > svg {
                display: none;
            }
        }
    }
`;
